var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 2H8.3C3.8 2 2 3.8 2 8.3V13.7C2 18.2 3.8 20 8.3 20H13.7C18.2 20 20 18.2 20 13.7V11.9",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.28 3.17086L7.02318 10.4287C6.74691 10.705 6.47063 11.2484 6.41538 11.6445L6.01939 14.4168C5.87204 15.4208 6.58114 16.1208 7.58494 15.9826L10.3569 15.5866C10.7437 15.5313 11.287 15.255 11.5725 14.9787L18.8293 7.72083C20.0818 6.4682 20.6711 5.01295 18.8293 3.17086C16.9875 1.32877 15.5324 1.91824 14.28 3.17086Z",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4C14.5425 5.93522 16.0567 7.44939 18 8",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.07df09970d652c65611f2afe9a8bcd5c.svg";
export { ForwardRef as ReactComponent };